import React, {useEffect, useState} from 'react';

import {View, Text, Image, StyleSheet, TouchableOpacity} from 'react-native';
import moment from 'moment';

import {colors} from '../../classes/Colors';
import InfoBar from './InfoBar';

const ImageNavCard = ({
  getImage,
  fallbackImage,
  title,
  subtitle,
  onPress,
  trust,
  isCompressed,
  displayDate,
  status,
  statusText,
  borderBottom,
}) => {
  const [loadedImage, setLoadedImage] = useState();

  useEffect(() => {
    const handleImage = async () => {
      const image = await getImage();
      setLoadedImage(image);
    };
    handleImage();
  }, [getImage]);

  const date = displayDate
    ? `${moment(displayDate).format('DD MMM YYYY')}`
    : '';
  const imageSource = loadedImage ? {uri: loadedImage} : fallbackImage;

  return (
    <TouchableOpacity onPress={onPress} activeOpacity={0.7}>
      <View
        style={[
          styles.container,
          borderBottom && {
            borderBottomWidth: 1,
            borderBottomColor: colors.Grey100,
            paddingBottom: 16,
          },
        ]}>
        <InfoBar
          trust={trust}
          value={date}
          status={status}
          statusText={statusText}
          isCompressed={isCompressed}
        />
        <View style={styles.content}>
          <Image source={imageSource} style={styles.image} resizeMode="cover" />
          <View style={styles.textContainer}>
            <Text
              ellipsizeMode="tail"
              numberOfLines={2}
              style={[styles.title, isCompressed && {paddingBottom: 0}]}>
              {title}
            </Text>
            {!isCompressed && (
              <Text
                ellipsizeMode="tail"
                numberOfLines={2}
                style={styles.subtitle}>
                {subtitle}
              </Text>
            )}
          </View>
        </View>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'column',
    backgroundColor: colors.white,
  },
  content: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  textContainer: {
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'center',
  },
  title: {
    fontSize: 16,
    fontWeight: '600',
    lineHeight: 24,
    marginRight: 8,
    marginBottom: 8,
    flexWrap: 'wrap',
    color: '#374044',
  },
  subtitle: {
    fontSize: 14,
    fontWeight: '400',
    lineHeight: 18,
    color: '#6D7378',
    maxHeight: 34,
  },
  image: {
    width: 171,
    height: 96,
    marginRight: 12,
    borderRadius: 5,
  },
});

export default ImageNavCard;
